import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { SupportComponent } from '@fuse/components/navigation/vertical/components/support/support.component';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
    selector     : 'thin-layout',
    templateUrl  : './thin.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ThinLayoutComponent implements OnInit, OnDestroy
{
    isScreenSmall: boolean;
    navigation: Navigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    user: User;

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _matDialog: MatDialog,
        private _userService: UserService,
        public _authService: AuthService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
         // Subscribe to the user service
         this._userService.user$
         .pipe((takeUntil(this._unsubscribeAll)))
         .subscribe((user: User) => {
             this.user = user;
             console.log('user', user)
         });

        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
                this.applyRuleNavigation();
                this.navigation.compact = navigation.compact.filter(n => !n.hidden(n));
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    private applyRuleNavigation() {
        const me = this;
    
        this.navigation.compact.forEach(menu => {
            let amountItemHidden = 0;
    
            const setHidden = (item, roles) => {
                item.hidden = () => {
                    const hasRequiredRole = roles.some(role => [me.user.role].includes(role));
                    return !hasRequiredRole; // Retorna true se o usuário não tiver a role necessária
                };
                
                if (item.hidden()) {
                    amountItemHidden++;
                }
            };
    
            if (menu.type === 'basic') {
                setHidden(menu, menu.role);
            }
    
            menu.children.forEach(child => {
                setHidden(child, child.role);
            });
    
            // Esconde o menu se todos os itens filhos estiverem escondidos ou se o menu básico estiver escondido
            if ((menu.type === 'basic' && amountItemHidden > 0) || (menu.children.length > 0 && amountItemHidden === menu.children.length)) {
                menu.hidden = () => true;
            }
        });
    
        console.log('applyRuleNavigation', this.navigation);
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    openSupportForm() {
        const dialogRef = this._matDialog.open(SupportComponent, {
                  
          width: '700px',
          height: '400px'
        });
    }
}
